import React from 'react';

interface IIConProps {
    width?: number;
    height?: number;
    fill?: string;
}

export const CursorInQr = ({ width = 48, height = 48, fill = '#D1D9E8' }: IIConProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 48 48"
        fill="none"
    >
        <g clipPath="url(#clip0ч_1151_2412)">
            <path
                d="M16 0H0V16H16V0ZM12 12H4V4H12V12ZM16 20H0V36H16V20ZM12 32H4V24H12V32ZM36 0H20V16H36V0ZM32 12H24V4H32V12ZM30 10H26V6H30V10ZM48 39.538V48H44V42.31L30 37.078V24.214C30 23.138 29.276 22.178 28.35 22.028C28.062 21.9768 27.7663 21.9894 27.4837 22.0649C27.2011 22.1405 26.9385 22.277 26.7144 22.4651C26.4903 22.6531 26.3102 22.888 26.1868 23.1532C26.0633 23.4184 25.9996 23.7075 26 24V47.424C26 47.424 17.398 40.574 17.36 40.538C16.9685 40.1962 16.4593 40.0201 15.9403 40.0469C15.4213 40.0737 14.933 40.3013 14.5787 40.6815C14.2244 41.0618 14.0319 41.5649 14.0419 42.0845C14.0518 42.6042 14.2634 43.0996 14.632 43.466L19.336 48.002H13.574L11.876 46.366C10.7551 45.2764 10.1038 43.7923 10.0606 42.2297C10.0173 40.667 10.5857 39.1493 11.6447 37.9993C12.7036 36.8494 14.1695 36.1582 15.7304 36.0728C17.2913 35.9874 18.8239 36.5145 20.002 37.542L21.998 39.13V24.004C21.998 22.24 22.77 20.574 24.114 19.432C24.7805 18.8667 25.5621 18.4533 26.4045 18.2205C27.2468 17.9877 28.1298 17.9411 28.992 18.084C31.846 18.548 33.998 21.188 33.998 24.218V34.308L47.998 39.54L48 39.538Z"
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id="clip0_1151_2412">
                <rect width="48" height="48" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
